import { LinearProgressStyled } from "./progressStyles"

export function Linear() {
  return (
    <LinearProgressStyled />
  );
}